<template>
    <div id="app" class="h-100">
        <router-view class="h-100"></router-view>
    </div>
</template>

<script>
import { mapMutations, mapActions, mapGetters } from 'vuex';
import supportChatMixin from '@/plugins/mixin/support-chat.mixin';

export default {
    name: 'app',
    mixins: [supportChatMixin],
    data() {
        return {
            show: true
        }
    },
    computed: {
        ...mapGetters('ui', ['language']),
        ...mapGetters('ui', ['sites'])
    },
    watch: {
        language() {
        this.$i18n.locale = this.language;
        },
        $route() {
        this.handleResize();
        },
        sites() {
            const { site_id } = this.$route.query;
            const site = this.sites.find(site => site.site_id === site_id);

            if (site) {
                this.applyTheme(site.name);
            } else {
                this.applyTheme('default');
            } 
        }

    },
    mounted() {
        this.initLanguage();
        this.getDeviceAccounts();
        this.getSites();
        this.hideSupportChatWhenEmbed();
    },
    methods: {
        ...mapMutations(['handleResize', 'setIntegration','setLanguage']),
        ...mapMutations('EcartNotifications', ['resetNotifications']),
        ...mapActions('EcartNotifications', ['fnApiGetPendingNotificationsCount', 'fnApiGetPendingNotifications']),
        ...mapMutations('session', ['readLocalSession']),
        ...mapActions('session', ['fnGetUserInfo']),
        ...mapActions('ui', ['getLanguages', 'setInitialLanguage', 'setLanguage', 'getSites']),
        ...mapActions('deviceAccounts', ['setAccounts']),
        initLanguage() {
        try {
            this.getLanguages();
            const query_params = new URLSearchParams(window.location.search);
            const lang_param = query_params.get('lang');
            const _v = query_params.get('_v')

            if (_v) {
            const decodedServiceData = Buffer.from(_v, 'base64');
            const parsedServiceData = JSON.parse(decodedServiceData.toString())
            const { lang } = parsedServiceData;

            if (lang) {
                this.setLanguage(lang);
            }
            }

            if (lang_param) {
            this.setLanguage(lang_param);
            }

            if (!_v && !lang_param) {
            this.setInitialLanguage();
            }
        } catch(error) {
            this.setLanguage('en-US');
        }
        },
        getDeviceAccounts() {
        let device_accounts = this.$cookies.get('_acli');
        
        if (device_accounts) {
            device_accounts = JSON.parse(Buffer.from(device_accounts, 'base64'));

            if (device_accounts) {
            this.setAccounts(device_accounts);
            }
        }
        },
        applyTheme(theme) {
            const themes = {
                'Ecart Pay': 'ecartpay',
                'Partners': 'partners',
                'Envia': 'envia',
                'WMS': 'wms',
                'Returns': 'returns',
                'Fulfillment': 'fulfillment',
                'default': 'default',
                'Ecart API': 'ecartapi',
            };

            theme = themes[theme] || 'default';

            const existingThemes = Object.values(themes).map(t => `theme-${t}`);
            existingThemes.forEach(t => {
                document.documentElement.classList.remove(t);
            });

            document.documentElement.classList.add(`theme-${theme}`);

            const temp = document.createElement('div');
            temp.style.display = 'none';
            temp.className = `theme-${theme}`;
            document.body.appendChild(temp);

            const styles = getComputedStyle(temp);
            for (let i = 0; i < styles.length; i++) {
                const name = styles[i];
                if (name.startsWith('--color-')) {
                    const value = styles.getPropertyValue(name);                    
                    document.documentElement.style.setProperty(name, value);
                }
            }

            document.body.removeChild(temp);
        }
    },
}
</script>

<style lang="scss">
@import url('https://fonts.googleapis.com/css2?family=Montserrat:wght@300;400;500;600;700;800;900&family=Inter:wght@300;400;500;600;700;800&display=swap');

#app {
  font-family: Montserrat, sans-serif;
}
</style>